import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from "../config/Params";
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useParams } from 'react-router-dom'; 
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

const Ratings = () => {
  const { listingId } = useParams();
  const [ratings, setRatings] = useState([]);
  const [userComments, setUserComments] = useState([]);
  const [activeReplyId, setActiveReplyId] = useState(null);
  const [replyTexts, setReplyTexts] = useState({});

  useEffect(() => {      
    const fetchRatingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.ratingList}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
            setRatings(response.data.ratings);
            setUserComments(response.data.user_comments || []);
        } else {
          console.log('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchRatingData();
  }, []);

  const CircularProgressBar = ({ percentage, value }) => {
    return (
      <div
        className="progress-circle"
        style={{ "--progress": `${percentage}%` }}
      >
        <span className="progress-text">{value}</span>
      </div>
    );
  };

  const toggleReplyBox = (id) => {
    setActiveReplyId(prev => prev === id ? null : id);
  };

  const handleReplyChange = (id, text) => {
    setReplyTexts(prev => ({ ...prev, [id]: text }));
  };

  const submitReply = async (ratingId) => {
    const hostData = getItemFromLocalStorage('hostProfile');
    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('rating_id', ratingId);
    formData.append('reply_text', replyTexts[ratingId] || '');

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.saveReply}`,
        data: formData,
      });
      if (response.data.status === 'ok') {
        toast.success('Reply saved successfully!');
        setUserComments(prevComments =>
          prevComments.map(comment =>
            comment.rating_id === ratingId
              ? { ...comment, reply_text: replyTexts[ratingId] }
              : comment
          )
        );
  
        setActiveReplyId(null);
        setReplyTexts(prev => ({ ...prev, [ratingId]: '' }));
      } else {
        toast.error('Failed to save reply.');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div>
        <Helmet>
            <title>Listing's Ratings</title>
            <meta name='description' content='' />
        </Helmet>

        <div className="ap-offer-section">
            <div className="apoffbx">
                {ratings.length > 0 ? (
                  <div className='row'>
                    {ratings.find(r => r.case === "overall_rating") && (
                      <div className='col-md-12 lb'>
                        <div className="rating-box">
                          <div className="ovalrtng-box">
                            <CircularProgressBar percentage={(ratings.find(r => r.case === "overall_rating").count / 5) * 100} value={ratings.find(r => r.case === "overall_rating").count} />
                            <div>
                              <div className="rtnicntxt">
                                <img src={ratings.find(r => r.case === "overall_rating").img} alt="wire stay" className="img-fluid" />
                                <h4>{ratings.find(r => r.case === "overall_rating").title}</h4>
                              </div>
                              <p className="rating-score">{ratings.find(r => r.case === "overall_rating").count} / 5</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {ratings.filter(r => r.case !== "overall_rating").map((rating, index) => (
                      <div key={index} className='col-md-4 lb'>
                        <div className="rating-box">
                          <div className="rtnicntxt">
                            <img src={rating.img} alt="wire stay" className="img-fluid" />
                            <h4>{rating.title}</h4>
                          </div>
                          <div className="progress">
                            <div 
                              className="progress-bar bg-black" 
                              role="progressbar" 
                              style={{ width: `${(rating.count / 5) * 100}%`, position:'inherit' }}
                              aria-valuenow={rating.count} 
                              aria-valuemin="0" 
                              aria-valuemax="5">
                            </div>
                          </div>
                          <p className="rating-score">{rating.count} / 5</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-chat-section ems">
                      <img src={'/assets/img/placeholder/no_rating_yet.svg'} className='empty-image img-fluid' alt='' />
                  </div>
                )}
            </div>

            <div className="user-comments-section mt-4">
              <h3>User Comments</h3>
              {userComments.length > 0 ? userComments.map(comment => (
                comment.user_comment ? (
                  <div key={comment.rating_id} className="comment-box mb-4 p-3 border rounded">
                    <p><strong>{comment.user_name}</strong> <small>({comment.rating_received_on})</small></p>
                    <p>{comment.user_comment}</p>

                    {comment.reply_text && (
                      <div className="mt-2 mb-4 ps-3 border-start border-2 border-primary">
                        <strong className="d-block mb-1">You replied:</strong>
                        <p className="mb-0">{comment.reply_text}</p>
                      </div>
                    )}

                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => toggleReplyBox(comment.rating_id)}
                    >
                      {activeReplyId === comment.rating_id ? "Cancel" : "Reply"}
                    </button>

                    {activeReplyId === comment.rating_id && (
                      <div className="mt-3">
                        <textarea
                          className="form-control mb-2"
                          placeholder="Write your reply..."
                          value={replyTexts[comment.rating_id] || ""}
                          onChange={(e) => handleReplyChange(comment.rating_id, e.target.value)}
                        />
                        <button className="btn btn-sm btn-success" onClick={() => submitReply(comment.rating_id)}>Submit Reply</button>
                      </div>
                    )}
                  </div>
                ) : null
              )) : <p></p>}
            </div>

        </div>
    </div>
  );
};

export default Ratings;
